import { Common } from '@thecvlb/design-system';
import classNames from 'classnames';

import NetworkQualityLevel from 'widgets/zoom/NetworkQualityLevel';

import { useZoomCall } from 'hooks';
import { useWidth } from 'hooks/useWidth';

import { useCallTimer } from './header.hook';
import { getHeaderBackgroundStyle } from './header.settings';

const Header = () => {
  const { appointment, isMinimize, isOpenChat, toggleIsMinimize, toggleIsOpenChat } = useZoomCall();
  const callTime = useCallTimer();
  const { isMobile } = useWidth();

  const handleOnTouchStart = () => {
    isOpenChat ? toggleIsOpenChat() : toggleIsMinimize();
  };
  const handleOnClick = () => {
    if (!isMobile) toggleIsMinimize();
  };

  const headerBackgroundStyle = getHeaderBackgroundStyle(isOpenChat, isMobile);

  return (
    <div
      className={classNames(
        'absolute inset-x-0 flex items-center justify-between px-5 py-3 md:p-4',
        {
          hidden: isMinimize,
          'md:pr-130': isOpenChat,
          'z-20': !(isOpenChat && isMobile),
          'z-30': isOpenChat && isMobile
        }
      )}
      style={headerBackgroundStyle}
    >
      <button
        className="flex items-center gap-2 text-start"
        onClick={handleOnClick}
        onTouchStart={handleOnTouchStart}
      >
        <Common.Icon
          className={classNames('size-6 text-white', {
            invisible: isMobile && isOpenChat
          })}
          name="arrow-left"
        />
        <Common.ProfileImage
          className={classNames({
            invisible: isMobile && isOpenChat
          })}
          size="lg"
          src={appointment?.staffImage}
        />
        <div>
          <h2
            className={classNames('text-mLg font-bold md:text-lg md:text-white', {
              'text-white': !isOpenChat
            })}
          >
            {appointment?.staffName}
          </h2>
          <span
            className={classNames('text-mSm font-semibold md:text-sm', {
              'text-gray': isOpenChat && isMobile,
              'text-gray-300': !(isOpenChat && isMobile)
            })}
          >
            {callTime}
          </span>
        </div>
      </button>
      <NetworkQualityLevel />
    </div>
  );
};

export default Header;
